<template>
  <div class="resume-container bgTable">
    <div ref="resumeChart"></div>
  </div>
</template>

<script>
import { makeChartOptions, makeChartObj, updateChartObj } from "@/utils/charts"

export default {
  name: "Resume",
  props: {
    resume: {
      type: Object,
      default: () => ({ activities: [] }) // Par défaut, une structure vide
    }
  },
  data() {
    return {
      chart: null
    }
  },
  computed: {
    isThemeDark() {
      return this.$store.state.app.isThemeDark
    }
  },
  methods: {
    getChartOptions(series) {
      return makeChartOptions({
        chart: { height: 400, type: "line" },
        isThemeDark: this.isThemeDark,
        series: series,
        titleText: this.$t("views.statistics.distribution"),
        tooltip: { x: { format: "dd MMM yyyy" } },
        xaxis: { type: "datetime" }
      })
    },
    getSeries() {
      const activitiesSeries = this.makeSerie(this.resume.activities)
      return [
        { name: this.$t("activities"), data: activitiesSeries },
      ]
    },
    makeChart() {
      if (!this.resume.activities || !this.resume.activities.length) {
        console.warn("No activities data available for chart")
        return
      }

      const series = this.getSeries()
      const options = this.getChartOptions(series)
      this.chart = makeChartObj(this.$refs.resumeChart, options)
    },
    makeSerie(data) {
      // Transforme les données au format attendu : [[timestamp, valeur], ...]
      return data.map(e => [new Date(e.date).getTime(), e.count])
    },
    updateChart() {
      if (!this.chart) {
        this.makeChart()
        return
      }

      const series = this.getSeries()
      const options = this.getChartOptions(series)
      updateChartObj(this.chart, options)
    }
  },
  mounted() {
    this.makeChart()
  },
  watch: {
    resume: {
      deep: true,
      handler() {
        this.updateChart()
      }
    },
    isThemeDark: {
      handler() {
        this.updateChart()
      }
    }
  }
}
</script>
<style scoped>
.resume-container {
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.chart-container {
  width: 100%;
  height: 100%;
}

.empty-state {
  text-align: center;
  color: #999999;
  font-size: 18px;
}
</style>